module.exports = __webpack_public_path__ + "static/media/icon-tapete.0f885d64.svg";